import React, { useState } from "react";
import AddLocationModal from "./CreateLocationModal";
import AddFacilityModal from "./CreateFacilityModal";

const CreateApartmentModal = ({
  isOpen,
  onClose,
  onSubmit,
  isUpdateMode,
  apartmentName,
  setApartmentName,
  location,
  setLocation,
  rooms,
  setRooms,
  size,
  setSize,
  bookingComId,
  setBookingComId,
  airbnbId,
  setAirbnbId,
  selectedFacilities,
  handleFacilityChange,
  selectedFiles,
  handleFileChange,
  error,
  locationList,
  facilities,
}) => {
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [isFacilityModalOpen, setIsFacilityModalOpen] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">
          {isUpdateMode ? "Update Apartment" : "Create New Apartment"}
        </h2>
        <form onSubmit={onSubmit}>
          {/* Apartment Name */}
          <div className="mb-4">
            <label className="block text-gray-700">Apartment Name</label>
            <input
              type="text"
              value={apartmentName}
              onChange={(e) => setApartmentName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          {/* Location */}
          <div className="mb-4">
            <label className="block text-gray-700 flex items-center">
              Location
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setIsLocationModalOpen(true)}
                  className="bg-blue-500 text-white px-2 py-1 rounded-md hover:bg-blue-600 ml-2"
                >
                  Add Location
                </button>
              </div>
            </label>
            <select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            >
              <option value="">Select Location</option>
              {locationList.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.name}
                </option>
              ))}
            </select>
          </div>

          {/* Rooms */}
          <div className="mb-4">
            <label className="block text-gray-700">Rooms</label>
            <input
              type="number"
              value={rooms}
              onChange={(e) => setRooms(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          {/* Size */}
          <div className="mb-4">
            <label className="block text-gray-700">Size (m²)</label>
            <input
              type="number"
              step="0.01"
              value={size}
              onChange={(e) => setSize(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          {/* Booking.com ID */}
          <div className="mb-4">
            <label className="block text-gray-700">Booking.com ID</label>
            <input
              type="text"
              value={bookingComId}
              onChange={(e) => setBookingComId(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Optional"
            />
          </div>

          {/* Airbnb ID */}
          <div className="mb-4">
            <label className="block text-gray-700">Airbnb ID</label>
            <input
              type="text"
              value={airbnbId}
              onChange={(e) => setAirbnbId(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Optional"
            />
          </div>

          {/* Facilities */}
          <div className="mb-4">
            <label className="block text-gray-700 flex items-center">
              Facilities
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setIsFacilityModalOpen(true)}
                  className="bg-blue-500 text-white px-2 py-1 rounded-md hover:bg-blue-600 ml-2"
                >
                  Add Facility
                </button>
              </div>
            </label>
            <div className="grid grid-cols-2 gap-4">
              {facilities.map((facility) => (
                <div key={facility.id} className="flex items-center">
                  <input
                    type="checkbox"
                    id={`facility-${facility.id}`}
                    checked={selectedFacilities.includes(facility.id)}
                    onChange={() => handleFacilityChange(facility.id)}
                    className="mr-2"
                  />
                  <label htmlFor={`facility-${facility.id}`} className="flex items-center">
                    <img
                      src={facility.logo}
                      alt={facility.name}
                      className="w-6 h-6 mr-2"
                    />
                    {facility.name}
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500 mb-4">{error}</p>}

          {/* Buttons */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white px-4 py-2 rounded-md mr-2 hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              {isUpdateMode ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>

      {/* Modals */}
      {isLocationModalOpen && (
        <AddLocationModal
          onClose={() => setIsLocationModalOpen(false)}
        />
      )}
      {isFacilityModalOpen && (
        <AddFacilityModal
          onClose={() => setIsFacilityModalOpen(false)}
        />
      )}
    </div>
  );
};

export default CreateApartmentModal;